import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import { API_BASE } from '../../api/request';

const resolveImageUrl = (url?: string) => {
  if (!url) return '';
  return url.startsWith('/') ? API_BASE + url : url;
};

const isLocalUploadUrl = (url?: string) => !!url && url.startsWith('/api/uploads/');

const SecureOrderImage: React.FC<{ url: string; width?: number }> = ({ url, width = 120 }) => {
  const [blobUrl, setBlobUrl] = useState('');
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    if (!url || !isLocalUploadUrl(url)) {
      setBlobUrl('');
      setLoadFailed(false);
      return;
    }

    let objectUrl = '';
    let disposed = false;

    const loadImage = async () => {
      try {
        setLoadFailed(false);
        setBlobUrl('');
        const token = localStorage.getItem('token');
        const response = await fetch(resolveImageUrl(url), {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        });

        if (!response.ok) throw new Error(`图片加载失败: ${response.status}`);

        const blob = await response.blob();
        objectUrl = URL.createObjectURL(blob);
        if (!disposed) setBlobUrl(objectUrl);
      } catch {
        if (!disposed) setLoadFailed(true);
      }
    };

    loadImage();

    return () => {
      disposed = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  if (!isLocalUploadUrl(url)) {
    return <Image src={resolveImageUrl(url)} width={width} />;
  }

  if (loadFailed) return <span>图片加载失败</span>;
  if (!blobUrl) return <span>图片加载中...</span>;
  return <Image src={blobUrl} width={width} />;
};

export default SecureOrderImage;
